import { createContext, useState } from "react";
import { useLocation, useRoute } from "wouter";
import useCheckMobileScreen from "../../checkMobileScreen";
import Cart from "../Cart/Cart";
import ProductOverlay from "../ProductOverlay/ProductOverlay";

export interface CartContent {
  cube: number;
  sphere: number;
  cone: number;
}

export interface CartContentContext {
  cart: CartContent;
  setCart: (cart: CartContent) => void;
}

const defaultCart = {
  cube: 0,
  sphere: 0,
  cone: 0,
};

export const CartContext = createContext<CartContentContext>({
  cart: defaultCart,
  setCart() {},
});

function Overlay() {
  const [, setLocation] = useLocation();
  const [, params] = useRoute("/item/:id");
  const mobileScreen = useCheckMobileScreen();
  const [cart, setCart] = useState<CartContent>({
    cube: 0,
    sphere: 0,
    cone: 0,
  });

  const color = params?.id ? "white" : "#4a4a4f";

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <CartContext.Provider value={{ cart: cart, setCart: setCart }}>
        <ProductOverlay mobileScreen={mobileScreen} />
        <div
          style={{
            position: "absolute",
            bottom: mobileScreen ? 20 : 40,
            left: mobileScreen ? 20 : 60,
            fontSize: "16px",
            color: color,
          }}
        >
          <a
            href="https://www.danielwikander.com"
            style={{ color: "inherit", textDecoration: "none" }}
          >
            © daniel wikander 2023
          </a>
        </div>
        <h4
          style={{
            position: "absolute",
            top: mobileScreen ? 0 : 20,
            left: mobileScreen ? 20 : 60,
            fontSize: mobileScreen ? "28px" : "32px",
            alignItems: "center",
            textDecoration: "none",
            textAlign: "center",
            color: color,
            marginTop: 16,
            cursor: "pointer",
            fontStyle: "italic",
          }}
          onClick={() => setLocation("/")}
        >
          ShapeShop
        </h4>

        <div
          style={{
            position: "absolute",
            top: mobileScreen ? 20 : 30,
            right: mobileScreen ? 20 : 30,
          }}
        >
          <Cart color={color} mobileScreen={mobileScreen} />
        </div>
      </CartContext.Provider>
    </div>
  );
}

export default Overlay;
